import { useIsMobileClientApp, useIsStubhub } from "src/shared/utils/appContextHelper";
import { useSellerHubPriceRecommendation } from "src/website-apps/shared/components/header/listing-notification/SellerHubPriceRecommendationContext";
import { useIsBottomNavEnabledWithoutParticipation } from "src/website-apps/shared/components/mobile-tab-navigation/hooks/useIsBottomNavEnabledWithoutParticipation";
import { UserEventToast } from "src/website-apps/shared/components/user-event-toast/UserEventToast";

const TOAST_APPEARANCE_DELAY_MS = 3000;

/**
 * User Event Toast Module on Home
 * @param {object} props
 * @param props.userEventOption
 * @param {boolean} [props.standAlone]
 * @param {Function} [props.onToastAvailabilityChange] - fired with true/false when the toast becomes renderable / unrenderable
 */
export const UserEventToastOnHome = ({ userEventOption, standAlone, onToastAvailabilityChange }) => {
  const bottomNavEnabled = useIsBottomNavEnabledWithoutParticipation();
  const { shouldSuppressCompetingToasts } = useSellerHubPriceRecommendation();
  const isMobileClientApp = useIsMobileClientApp();
  const isStubhub = useIsStubhub();
  const enableToastDelay = isMobileClientApp && isStubhub && userEventOption !== null;

  if (!userEventOption || shouldSuppressCompetingToasts) {
    return null;
  }

  return (
    <UserEventToast
      bottomNavEnabled={bottomNavEnabled}
      userEventOption={userEventOption}
      delayMs={enableToastDelay ? TOAST_APPEARANCE_DELAY_MS : 0}
      standAlone={standAlone}
      onToastAvailabilityChange={onToastAvailabilityChange}
    />
  );
};
